<template>
  <span>{{ assetTypeLabel }}</span>
</template>

<script>
import { getAssetType } from '@/dataAccess/assetTypes'

export default {
  name: 'AssetTypeLabel',
  props: {
    assetType: { type: String, required: true }
  },
  computed: {
    assetTypeLabel() {
      return getAssetType(this.assetType).label
    }
  }
}
</script>
